import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box } from '@primer/react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Box display="grid" gridTemplateColumns={['1fr', null, null, null, '1fr 2fr']} gridGap={4} mdxType="Box">
  <div>
        <p><a parentName="p" {...{
            "href": "/components/action-bar"
          }}><img parentName="a" {...{
              "src": "https://user-images.githubusercontent.com/378023/188890108-a587272b-56fd-4833-9b4b-b79eece66643.png",
              "alt": "''"
            }}></img></a></p>
  </div>
  <div>
        <h4><a parentName="h4" {...{
            "href": "/components/action-bar"
          }}>{`Action bar`}</a></h4>
        <p>{`An action bar contains a collection of horizontally aligned icon buttons. When there is not enough space, icon buttons that don't fit will be added to an overflow menu.`}</p>
  </div>
  <div>
        <p><a parentName="p" {...{
            "href": "/components/action-list"
          }}><img parentName="a" {...{
              "src": "https://user-images.githubusercontent.com/293280/123880841-54bb9280-d8f8-11eb-9a6f-4c33c8196fbf.png",
              "alt": "''"
            }}></img></a></p>
  </div>
  <div>
        <h4><a parentName="h4" {...{
            "href": "/components/action-list"
          }}>{`Action list`}</a></h4>
        <p>{`An action list is a vertical list of interactive actions or options. It’s composed of items presented in a consistent single-column format, with room for icons, descriptions, side information, and other rich visuals.`}</p>
  </div>
  <div>
        <p><a parentName="p" {...{
            "href": "/components/autocomplete"
          }}><img parentName="a" {...{
              "src": "https://user-images.githubusercontent.com/2313998/138136338-046aa39b-51bc-4009-b465-b9d47500ee88.png",
              "alt": "''"
            }}></img></a></p>
  </div>
  <div>
        <h4><a parentName="h4" {...{
            "href": "/components/autocomplete"
          }}>{`Autocomplete`}</a></h4>
        <p>{`Autocomplete inputs allow users to quickly filter through a list of options to pick one or more values for a field.`}</p>
  </div>
  <div>
        <p><a parentName="p" {...{
            "href": "/components/comment-box"
          }}><img parentName="a" {...{
              "src": "https://user-images.githubusercontent.com/378023/191678010-124e429a-4eed-4f68-980a-a0bbf0c4f907.png",
              "alt": "''"
            }}></img></a></p>
  </div>
  <div>
        <h4><a parentName="h4" {...{
            "href": "/components/comment-box"
          }}>{`Comment box`}</a></h4>
        <p>{`A comment box allows users to write and preview comments.`}</p>
  </div>
  <div>
        <p><a parentName="p" {...{
            "href": "/components/dialog"
          }}><img parentName="a" {...{
              "src": "https://user-images.githubusercontent.com/18661030/187487523-49383638-cbf8-4b27-89f3-b9a288aebfe7.png",
              "alt": "''"
            }}></img></a></p>
  </div>
  <div>
        <h4><a parentName="h4" {...{
            "href": "/components/dialog"
          }}>{`Dialog`}</a></h4>
        <p>{`A Dialog is a floating surface used to display transient content such as confirmation actions, selection options, and more.`}</p>
  </div>
  <div>
        <p><a parentName="p" {...{
            "href": "/components/filter-input"
          }}><img parentName="a" {...{
              "src": "https://user-images.githubusercontent.com/18661030/187487523-49383638-cbf8-4b27-89f3-b9a288aebfe7.png",
              "alt": "''"
            }}></img></a></p>
  </div>
  <div>
        <h4><a parentName="h4" {...{
            "href": "/components/filter-input"
          }}>{`Filter input`}</a></h4>
        <p>{`A input that provides suggestions through qualifiers and highlights complex filter syntax.`}</p>
  </div>
  <div>
        <p><a parentName="p" {...{
            "href": "/components/toggle-switch"
          }}><img parentName="a" {...{
              "src": "https://user-images.githubusercontent.com/2313998/159758160-9d6b52ec-34f3-4fd8-b4ae-25b523dd3c0f.png",
              "alt": "''"
            }}></img></a></p>
  </div>
  <div>
        <h4><a parentName="h4" {...{
            "href": "/components/toggle-switch"
          }}>{`Toggle switch`}</a></h4>
        <p>{`A toggle switch is used to immediately toggle a setting on or off.`}</p>
  </div>
  <div>
        <p><a parentName="p" {...{
            "href": "/components/tokens"
          }}><img parentName="a" {...{
              "src": "https://user-images.githubusercontent.com/2313998/138136341-c85ccaf9-f83f-4933-9fde-9a7b9c630fe4.png",
              "alt": "''"
            }}></img></a></p>
  </div>
  <div>
        <h4><a parentName="h4" {...{
            "href": "/components/tokens"
          }}>{`Tokens`}</a></h4>
        <p>{`A token is a compact representation of an object, and is typically used to show a collection of related metadata.`}</p>
  </div>
    </Box>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      